import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getBodyPattern } from '../../Redux/Action/getBodyPattern';
import { getSleevePattern } from '../../Redux/Action/getSleevePattern';
import { getCapPattern } from '../../Redux/Action/getCapPattern';
import { Button, Select } from 'antd';
import { useParams } from 'react-router-dom';
// import newSgvData from '../../Data/svg1';
import fourthSvgData from '../../Data/Svg3';
import { PDFDocument } from "pdf-lib";

const ShirtThreeDisplay = ({
  capColors,
  capMarkingColor,
  sleeveColors,
  sleevesMarkingColor,
  bodyColors,
  bodyMarkingColors,
  bodyId,
  capId,
  sleevesID,
}) => {
  const dispatch = useDispatch();
  const bodyData = useSelector((state) => state.getBodyPattern.data);
  const sleeveData = useSelector((state) => state.getSleevePattern.data);
  const capData = useSelector((state) => state.getCapPattern.data);
  const svgRef = useRef(null);
  const { id } = useParams();
  const [downloadFormat, setDownloadFormat] = useState("svg");
  const waterMark = {
    fillRule: "evenodd",
    opacity: 0.15,
  };

  const handleFormatChange = (value) => {
    setDownloadFormat(value);
  };
  useEffect(() => {
    const ShirtType = id;
    dispatch(getBodyPattern(ShirtType));
    dispatch(getSleevePattern(ShirtType));
    dispatch(getCapPattern(ShirtType));
  }, [dispatch]);

  const downloadImage = () => {
    const svg = svgRef.current;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const svgSize = svg.getBoundingClientRect();
    canvas.width = svgSize.width;
    canvas.height = svgSize.height;
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = async () => {
      ctx.drawImage(img, 0, 0);
      let dataURL;
      if (downloadFormat === "svg") {
        dataURL = "data:image/svg+xml;base64," + btoa(svgData);
      } else if (downloadFormat === "png") {
        dataURL = canvas.toDataURL("image/png");
      } else if (downloadFormat === "jpg") {
        dataURL = canvas.toDataURL("image/jpeg");
      } else if (downloadFormat === "pdf") {
        const pdfDoc = await PDFDocument.create();
        const page = pdfDoc.addPage([svgSize.width, svgSize.height]);
        const pngImage = await pdfDoc.embedPng(canvas.toDataURL("image/png"));
        page.drawImage(pngImage, {
          x: 0,
          y: 0,
          width: svgSize.width,
          height: svgSize.height,
        });
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "image.pdf";
        link.click();
        return;
      }
      const link = document.createElement("a");
      link.download = `image.${downloadFormat}`;
      link.href = dataURL;
      link.click();
    };

    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  return (
    <div className="imageeeSvg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 650 1010"
        width="100%"
        height="auto"
        ref={svgRef}
        className="shirtsvg"
        style={{ background: "#FFF" }}
      >
        {fourthSvgData?.svg.elements?.map((item) => (
          <g data-name="Layer 1">
            {item.id == "body-button-color" && (
              <g id="body-button-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "left-body-border" && (
              <g id="left-body-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "left-body-color" && (
              <g id="left-body-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "right-body-border" && (
              <g id="left-body-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "right-body-color" && (
              <g id="right-body-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}

            {item.id == "right-sleeve-border" && (
              <g id="right-sleeve-border">
                <path d={item.d} />
              </g>
            )}

            {item.id == "right-sleeve-color" && (
              <g id="right-sleeve-color">
                <path style={sleeveColors} d={item.d} />
              </g>
            )}

            {item.id == "left-collar-color" && (
              <g id="left-collar-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "left-collar-border" && (
              <g id="left-body-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "right-collar-border" && (
              <g id="left-body-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            {item.id == "right-collar-color" && (
              <g id="right-collar-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}

            {item.id == "main-collar-color" && (
              <g id="main-collar-color">
                <path style={bodyColors} d={item.d} />
              </g>
            )}
            <g>
              {item.id == "cap-front" && (
                <g id="cap-front">
                  <path style={capColors} d={item.d} />
                </g>
              )}

              {item.id == "cap-upper" && (
                <g id="cap-upper">
                  <path style={capColors} d={item.d} />
                </g>
              )}
            </g>

            {item.id == "abc" && (
              <g id="abc">
                <path d={item.d} />
              </g>
            )}

            {item.id == "button-1" && (
              <g id="button-1">
                <circle cx={item.cx} cy={item.cy} r={item.r} />
              </g>
            )}

            {item.id == "button-2" && (
              <g id="button-2">
                <circle cx={item.cx} cy={item.cy} r={item.r} />
              </g>
            )}
            {item.id == "button-3" && (
              <g id="button-3">
                <circle cx={item.cx} cy={item.cy} r={item.r} />
              </g>
            )}

            {item.id == "button-4" && (
              <g id="button-4">
                <circle cx={item.cx} cy={item.cy} r={item.r} />
              </g>
            )}

            {item.id == "button-5" && (
              <g id="button-5">
                <circle cx={item.cx} cy={item.cy} r={item.r} />
              </g>
            )}
          </g>
        ))}

        {bodyData?.items?.map(
          (item, index) =>
            bodyId === item._id && (
              <svg
                key={index}
                className="bboddy"
                style={{ strokeWidth: "3" }}
                dangerouslySetInnerHTML={{
                  __html: `${item.SvgPath.replace(
                    /^<div>|<\/div>$/g,
                    ""
                  )}<style>.bboddy path { fill: ${
                    bodyMarkingColors.fill
                  }; } .bboddy polygon { fill: ${
                    bodyMarkingColors.fill
                  }; } .bboddy rect { fill: ${
                    bodyMarkingColors.fill
                  }; } .bboddy ellipse { fill: ${
                    bodyMarkingColors.fill
                  }; } .bboddy circle { fill: ${
                    bodyMarkingColors.fill
                  }; } .bboddy polyline { fill: ${
                    bodyMarkingColors.fill
                  }; } .bboddy line { fill: ${
                    bodyMarkingColors.fill
                  }; }</style>`,
                }}
              />
            )
        )}

        {fourthSvgData?.svg.elements?.map((item) => (
          <g>
            {item.id == "left-sleeve-border" && (
              <g id="left-sleeve-border">
                <path d={item.d} />
              </g>
            )}

            {item.id == "left-sleeve-color" && (
              <g id="left-sleeve-color">
                <path style={sleeveColors} d={item.d} />
              </g>
            )}
          </g>
        ))}

        {sleeveData?.items?.map(
          (item, index) =>
            sleevesID === item._id && (
              <svg
                key={index}
                className="ssleevvee"
                style={{ strokeWidth: "3" }}
                dangerouslySetInnerHTML={{
                  __html: `${item.SvgPath.replace(
                    /^<div>|<\/div>$/g,
                    ""
                  )}<style>.ssleevvee path { fill: ${
                    sleevesMarkingColor.fill
                  }; } .ssleevvee circle { fill: ${
                    sleevesMarkingColor.fill
                  }; } .ssleevvee polygon{fill: ${
                    sleevesMarkingColor.fill
                  }; } .ssleevvee rect {fill: ${
                    sleevesMarkingColor.fill
                  }; } .ssleevvee ellipse {fill: ${
                    sleevesMarkingColor.fill
                  }; } .ssleevvee polyline {fill: ${
                    sleevesMarkingColor.fill
                  }; } .ssleevvee line {fill: ${
                    sleevesMarkingColor.fill
                  }; }</style>`,
                }}
              />
            )
        )}

        {capData?.items?.map(
          (item, index) =>
            capId === item._id && (
              <svg
                key={index}
                className="ccaapp"
                style={{ strokeWidth: "3" }}
                dangerouslySetInnerHTML={{
                  __html: `${item.SvgPath.replace(
                    /^<div>|<\/div>$/g,
                    ""
                  )}<style>.ccaapp path { fill: ${
                    capMarkingColor.fill
                  }; } .ccaapp circle { fill: ${
                    capMarkingColor.fill
                  }; } .ccaapp rect { fill: ${
                    capMarkingColor.fill
                  }; } .ccaapp polygon { fill: ${
                    capMarkingColor.fill
                  }; } .ccaapp ellipse { fill: ${
                    capMarkingColor.fill
                  }; } .ccaapp line { fill: ${
                    capMarkingColor.fill
                  }; } .ccaapp polyline { fill: ${
                    capMarkingColor.fill
                  }; }</style>`,
                }}
              />
            )
        )}
        <g id="eeellleBody">
          {fourthSvgData?.svg.elements?.map((item) => (
            <g>
              {item.id == "watermark" && (
                <g id="watermark">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-1" && (
                <g id="watermark-1">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-2" && (
                <g id="watermark-2">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-3" && (
                <g id="watermark-3">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-4" && (
                <g id="watermark-4">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-5" && (
                <g id="watermark-5">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-6" && (
                <g id="watermark-6">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-7" && (
                <g id="watermark-7">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}

              {item.id == "watermark-8" && (
                <g id="watermark-8">
                  <path style={waterMark} d={item.d} id="eeellleBody" />
                </g>
              )}
            </g>
          ))}
        </g>
      </svg>

      <Select
        value={downloadFormat}
        onChange={handleFormatChange}
        style={{ margin: "10px 0" }}
      >
        <Select.Option value="svg">Download as SVG</Select.Option>
        <Select.Option value="png">Download as PNG</Select.Option>
        <Select.Option value="jpg">Download as JPEG/JPG</Select.Option>
        <Select.Option value="pdf">Download as PDF</Select.Option>
      </Select>

      <div className="button">
        <Button className="downLOad" onClick={downloadImage}>
          Download
        </Button>
      </div>
    </div>
  );
};

export default ShirtThreeDisplay